import { Injectable } from '@angular/core';
import { DisplayMessage } from '../../sb-model/display-message';
import { DisplayMessageFile } from '../../sb-model/display-message-file';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
/**
 * Begründung: Dies ist nur einer Helferklasse um Nachrichten editieren zu können.
 */
export class EditMessageService {
  private readonly editRequest = new Subject<DisplayMessage | DisplayMessageFile>();
  editRequest$ = this.editRequest.asObservable();

  /**
   * Hier wird der Content der Message wieder in den Editor gesetzt, dabei wird unterschieden zwischen einer
   * Nachricht die ein File beinhaltet oder nicht.
   * @param message
   */
  setMessageIntoEditor(message: DisplayMessage | DisplayMessageFile): void {
    this.editRequest.next(message);
  }
}
